<template>
  <div>
    <div class="register-page">
      <status-bar :title="$t('diya-check-data.title')" />
      <validation-observer
        v-slot="{ invalid }"
        ref="observer"
        slim
      >
        <icu-loader v-if="isLoading" />
        <div v-else class="register-page-form">

          <form-wrapper>
            <form-group class="diya-check">
              <form-group-title class="register-group-title">
                {{ $t('diya-check-data.contacts-title') }}
              </form-group-title>
              <div v-for="key in Object.keys($options.fields.step1)" :key="key" class="register-row">
                <div class="register-label">
                  {{ $t($options.fields.step1[key]) }}:
                </div>
                <div v-if="['photo_inn'].includes(key)">
                  <span v-for="(data,index) in formData[key]" :key="data.id">
                    <span v-if="index > 0">, </span>
                    <a
                      @click="showDoc(data)"
                    >
                      {{ data.name }}
                    </a>
                  </span>
                </div>
                <div v-else class="register-value">
                  {{ formData[key] }}
                </div>
              </div>
              <employment-step
                :step-form-data="formData.employment"
                :backend-errors="backendErrors.employment"
                @update-field="updateField($event.formKey, $event.value)"
              ></employment-step>
            </form-group>

            <form-group>
              <form-group-title class="register-group-title">
                {{ $t('diya-check-data.document-title') }}
              </form-group-title>
              <div class="register-row">
                <div class="register-label">
                  {{ $t($options.fields.step2['document']) }}:
                </div>
                <div class="register-value">
                  {{ formData.passport.text }}
                </div>
              </div>
              <div class="register-row">
                <div class="register-label">
                  {{ $t($options.fields.step2['photo_document']) }}:
                </div>
                <div class="register-value">
                  <span v-for="(data,index) in formData.passport.photo" :key="data.id">
                    <span v-if="index > 0">, </span>
                    <a
                      @click="showDoc(data)"
                    >
                      {{ data.name }}
                    </a>
                  </span>
                </div>
              </div>
            </form-group>

            <form-group>
              <form-group-title>{{ $t('diya-check-data.address-title') }}</form-group-title>
              <third-step
                :hide-subtitles="true"
                :step-form-data="addressData"
                :is-resident="true"
                :is-citizen="true"
                :backend-errors="backendErrors"
                :disabled-fields="disabledFields"
                :is-migrant-checkbox-disabled="isMigrantCheckboxDisabled"
                :is-diya-check-data="true"
                @add-file="addFile"
                @delete-file="deleteFile"
                @update-field="updateField($event.formKey, $event.value)"
              ></third-step>
            </form-group>


            <!--            <form-group>-->
            <!--              <form-group-title>-->
            <!--                {{ $t('diya-check-data.account-title') }}-->
            <!--              </form-group-title>-->
            <!--              <validation-observer-->
            <!--                v-slot="{ valid }"-->
            <!--                ref="observer"-->
            <!--                slim-->
            <!--              >-->
            <!--                <fourth-step-->
            <!--                  :step-form-data="formData.accounts"-->
            <!--                  :is-resident="true"-->
            <!--                  :settings="formSettings"-->
            <!--                  :backend-errors="backendErrors.accounts"-->
            <!--                  @add-card="addCard"-->
            <!--                  @delete-card="deleteCard"-->
            <!--                  @add-file="addFile($event, 'accounts')"-->
            <!--                  @delete-file="deleteFile($event, 'accounts')"-->
            <!--                  @delete-array-item="deleteArrayItem"-->
            <!--                  @update-field="updateField($event.formKey, $event.value, 'accounts')"-->
            <!--                />-->
            <!--                <div class="register-page-form-actions">-->
            <!--                  <icu-button-->
            <!--                    v-if="showAddAccountButton && valid"-->
            <!--                    icon-left-name="plus"-->
            <!--                    @click="addAccount"-->
            <!--                  >-->
            <!--                    {{ $t('application-form.add-another-account') }}-->
            <!--                  </icu-button>-->
            <!--                </div>-->
            <!--              </validation-observer>-->
            <!--            </form-group>-->

            <form-group>
              <form-group-title>
                {{ $t('diya-check-data.fatca-title') }}
              </form-group-title>
              <step-fatca
                :step-form-data="formData.fatcadata"
                :is-resident="true"
                :backend-errors="backendErrors"
                @update-field="updateField($event.formKey, $event.value, 'fatcadata')"
              ></step-fatca>
            </form-group>

            <form-group>
              <form-group-title>
                {{ $t('diya-check-data.business-point-title') }}
              </form-group-title>
              <fifth-step
                :step-form-data="formData"
                :backend-errors="backendErrors"
                @update-field="updateField($event.formKey, $event.value)"
              />
            </form-group>
          </form-wrapper>

          <div class="buttons">
            <div class="btn-hint">
              {{ $t('diya-check-data.press-to-send') }}
            </div>
            <pc-button variant="dark" :disabled="invalid" @click="confirmData">
              <icu-icon v-if="isSending" class="pc-small-loader"></icu-icon>
              <template v-else>
                {{ $t('qr-code.confirm-data') }}
              </template>
            </pc-button>
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

    <script>
    import {mapActions, mapGetters} from 'vuex'
    import StatusBar from '@/components/views/RegisterPage/StatusBar'
    import FormWrapper from '@/components/views/RegisterPage/FormWrapper'
    import FormGroup from '@/components/views/RegisterPage/FormGroup'
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import FormGroupTitle from '@/components/views/RegisterPage/FormGroupTitle'
    import FourthStep from '@/components/views/RegisterPage/steps/FourthStep'
    import FifthStep from '@/components/views/RegisterPage/steps/FifthStep'
    import StepFatca from '@/components/views/RegisterPage/steps/StepFatca'
    import ThirdStep from '@/components/views/RegisterPage/steps/ThirdStep'
    import EmploymentStep from '@/components/views/RegisterPage/EmploymentStep'
    import PcButton from '@/components/common/PcButton.vue'
    import {api} from '@/api/api'
    import {cloneDeep, get, setWith} from 'lodash'
    import {makePreviewFromImage} from '@/utils'
    import { v4 as uuidv4 } from 'uuid'
    import IcuLoader from '@/components/common/IcuLoader'
    import IcuIcon from '@/components/common/IcuIcon.vue'

    export default {
      name: 'DiyaCheckData',
      components: {
        IcuIcon,
        IcuLoader,
        PcButton,
        EmploymentStep,
        ThirdStep,
        StepFatca,
        FifthStep,
        // FourthStep,
        FormGroupTitle,
        StatusBar,
        ValidationObserver,
        // ValidationProvider,
        FormWrapper,
        FormGroup
      },
      fields: {
        step1: {
          phone: 'application-form.step-1.phone',
          email: 'application-form.step-1.email',
          last_name: 'application-form.step-1.last-name',
          first_name: 'application-form.step-1.first-name',
          middle_name: 'application-form.step-1.middle-name',
          birth_date: 'application-form.step-1.date-of-birth',
          birth_city: 'application-form.step-1.place-of-birth',
          citizenship: 'application-form.step-1.citizenship',
          residency: 'application-form.step-1.residency',
          inn: 'application-form.step-1.tax-id-number',
          photo_inn: 'application-form.step-1.photo-tax-id-number',
        },
        step2: {
          document: 'application-form.step-2.id-document-subtitle',
          photo_document: 'application-form.step-2.photo-doc-short'
        }
      },
      fileFieldNames: [
        'photo_inn',
        'photo',
        'photo_45',
        'photo_register',
        'photo_migrant_reference',
        'doc',
        'photo_selfie'
      ],
      accountDataTemplate: {
        iban: '',
        swift:'',
        additional_information:'',
        currency: [],
        doc: [],
        cards:[]
      },
      cardDataTemplate:{
        card_number: '',
        card_expire: '',
        doc: []
      },
      fatcadata: {
        is_usa_citizen: false,
        title: false,
        has_residence: false,
        is_usa_born: false,
        has_usa_address: false,
        has_usa_phone: false,
        has_usa_payment_order: false,
        has_usa_p_a: false,
        tin_code: null
      },
      uuidv4,

      data() {
        return {
          isLoading: true,
          disabledFields:[],
          formSettings: {},
          isMigrantCheckboxDisabled: false,
          formData: {},
          backendErrors:{},
          isSending: false
        }
      },

      computed: {
        ...mapGetters(['userInfo']),
        addressData() {
          const {
            registration_address,
            living_address,
            registration_is_living,
            is_internal_migrant,
            photo_migrant_reference } = this.formData

          return {registration_address,
            living_address,
            registration_is_living,
            is_internal_migrant,
            photo_migrant_reference }
        },

        showAddAccountButton() {
          return  this.formData.accounts.length < this.formSettings.MAX_ACCOUNTS_COUNT
        },

        processedCurrentFormData() {
          return this.processFormDataObject(this.formData)
        },
      },

      async mounted() {

          try {
            const {data} = await api.profile.resident.sharingData.get()
            this.formData = data
            if (this.formData.registration_address) {
              this.disabledFields.push('registration_address')
            }
          } catch (err) {
            if (err.response.data._error_code === 'FullSentProfile') {
              await this.$router.push({name: 'document-sign'})
            }
          }

          if (!this.formData.employment) {
            this.formData.employment = {
              type: '',
              income_level: ''
            }
          }
          this.$set(this.formData, 'fatcadata', this.$options.fatcadata)
          if (!this.formData.accounts?.length) {
            this.addAccount()
          }
          try {
            const {data} = await api.profile.settings()
            this.formSettings = data
          } catch (err) {
            console.log(err)
          }
          if (this.formData.is_internal_migrant && this.formData.photo_migrant_reference.length) {
            this.isMigrantCheckboxDisabled = true
          }
          this.isLoading = false

      },

      methods: {
        ...mapActions(['setUserInfo']),
        updateField(key, value, group){
          if(group) {
            setWith(this.formData[group], key, value, (nsValue, key, nsObject) => {
              return this.$set(nsObject, key, nsValue)
            })
          } else {
            setWith(this.formData, key, value, (nsValue, key, nsObject) => {
              return this.$set(nsObject, key, nsValue)
            })
          }
        },

        addAccount() {
          if(this.formData.accounts) {
            this.formData.accounts?.push(cloneDeep(this.$options.accountDataTemplate))
            const idx = this.formData.accounts.length - 1
          }
        },

        deleteArrayItem(formKey) {
          this.formData.accounts.splice(formKey, 1)
        },

        addCard(idx){
          const cardDataTemplate = cloneDeep(this.$options.cardDataTemplate)
          cardDataTemplate.id = this.$options.uuidv4()
          this.formData.accounts[idx].cards.push(cardDataTemplate)
        },

        deleteCard(idx, cardIndex){
          this.formData.accounts[idx].cards.splice(cardIndex, 1)
        },

        async addFile({formKey, file}, group) {
          let fileData = {
            _id: this.$options.uuidv4(),
            name: file.name,
            newAdded: true,
            isUploading: false,
            hasError: false,
            uploadPercent: 0,
            file
          }
          if (file.type.includes('image')) {
            fileData.src = await makePreviewFromImage(file)
          }

          let newFileArray = []
          if(group) {
            newFileArray = [
              ...get(this.formData[group], formKey),
              fileData
            ]
          } else {
            newFileArray = [
              ...get(this.formData, formKey),
              fileData
            ]
          }

          this.updateField(formKey, newFileArray, group)

          if (file.type.includes('image')) {
            fileData.src = await makePreviewFromImage(file)
          }
        },

        deleteFile(fileData, group) {
          const formKey = fileData.formKey
          const data = group ? this.formData[group] : this.formData
          const newFileArray = get(data, formKey).filter(file => file._id !== fileData.file._id)
          this.updateField(formKey, newFileArray, group)
        },

        async confirmData(){
          this.isSending = true
          const fileErrors = {}
          try {
            const res = await this.uploadFiles()
            res.filter(el => {
              if (el.hasError) {
                if(Array.isArray(el.field)) {
                  fileErrors[el.field[0]] = {[el.field[1]]: {[el.field[2]]: ['']} }
                }else {
                  fileErrors[el.field] = ['']
                }
              }
            })
            if (Object.keys(fileErrors).length) {
              this.backendErrors = fileErrors
              throw new Error()

            }
          }catch(e){
            this.isLoading = false
            return true
          }
          try {
            await api.profile.resident.sharingData.post(this.processedCurrentFormData)
            await this.$router.push({name: 'document-sign'})
          } catch(err) {
            this.backendErrors = err.response.data
            this.scrollToFirstError()
            console.log(err)
          }

          this.isSending = false
        },

        async uploadFiles(){

          const filesToUpload = this.collectNewFilesToUpload()
          await Promise.all(filesToUpload.map(fileData => this.uploadFile(fileData)))
          return filesToUpload
        },

        async uploadFile(fileData){
          fileData.isUploading = true

          const formData = new FormData()
          formData.append('doc', fileData.file)

          const onUploadProgressCallback = ev => {
            fileData.uploadPercent = Math.round(ev.loaded * 100 / ev.total)
          }

          try {
            const { data } = await api.profile.uploadFile(formData, onUploadProgressCallback)
            Object.assign(fileData, data)

          } catch (e) {
            fileData.error = e.response.data.doc
            fileData.hasError = true
          } finally {
            fileData.isUploading = false
            fileData.newAdded = fileData.hasError
          }

        },

        collectNewFilesToUpload(){
          const filesToUpload = []
          for(const key in this.formData) {
            if(key === 'accounts'){
              this.formData.accounts.forEach((account, index) => {
                for(const k in account) {
                  if (k === 'cards') {
                    const files = []
                    account.cards.forEach((el, index) => {
                      const docs = el.doc.map(doc => {
                        doc.field = ['cards', index, 'doc']
                        return doc
                      })
                      files.push(...docs.filter(file => file.newAdded))

                    })
                    if(files.length) {
                      filesToUpload.push(...files)
                    }
                  }
                  if (this.$options.fileFieldNames.includes(k)) {
                    const files = this.addFileToCollection(k, 'accounts', index)
                    filesToUpload.push(...files)
                  }
                }
              })
            }

            if (this.$options.fileFieldNames.includes(key)) {
              const files = this.addFileToCollection(key)
              filesToUpload.push(...files)
            }
          }
          return filesToUpload
        },
        scrollToFirstError() {
          setTimeout(()=>{
            const firstErrorElement = document.querySelector('.error-text')
            firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
            console.log(firstErrorElement)
          },0)
        },
        addFileToCollection(key, group = null, index= null){
          const files = group ? this.formData[group][index][key] : this.formData[key]
          const newFiles = files.map(file => {
            file.field = key
            return file
          })
          .filter(file => file.newAdded)

          if (newFiles.length) {
            return newFiles
          }
          return []
        },
        processFormDataObject(itemObj) {
          const processedFormData = {}
          const itemObjCopy = cloneDeep(itemObj)
          Object.entries(itemObjCopy).forEach(([fieldName, value]) => {
            if (this.$options.fileFieldNames.includes(fieldName)) {
              processedFormData[fieldName] = value.filter(fileData => !fileData.hasError).map(fileData => fileData.id)
            }else if(fieldName === 'accounts'){
              processedFormData[fieldName] = value.map((el) => this.processFormDataObject(el))
            }else if(fieldName === 'cards'){
              processedFormData[fieldName] = value.filter(el => !!el.card_number)
              processedFormData.cards = value.map(card => {
                card.doc = card.doc.filter(fileData => !fileData.hasError).map(fileData => fileData.id)
                return card
              })

            } else {
              processedFormData[fieldName] = value
            }
          })

          return processedFormData
        },


        async showDoc(data){
          const id = data.uuid
          const fileNameArray = data.name.split('.')
          const fileExtension = fileNameArray[fileNameArray.length -1]
          let mimeType = getMimeType(fileExtension)
          try{
            const res = await api.profile.downloadDoc(id)
            const blob = new Blob([res.data], { type: mimeType })
            const url = window.URL || window.webkitURL
            const link = url.createObjectURL(blob)
            const a = document.createElement('a')
            a.setAttribute('href', link)
            if(!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
              a.setAttribute('target', '_blank')
            }
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)

          }catch(err){
            console.log(err)
            this.$toast.error(this.$t('notifications.something-went-wrong'))
          }

          function getMimeType(str) {
            if (str === 'pdf') {
              return 'application/pdf'
            }
            if (str === 'jpg') {
              return 'image/jpeg'
            }
            return 'image/' + str
          }
        },
      }
    }
    </script>


    <style scoped lang="scss">
    @import "~@/assets/scss/theme.scss";
    @import "~@/assets/scss/views/register-common.scss";

    .register {
      &-row {
        display: flex;
        justify-content: space-between;
        font-size: 15px;
        color: $gray-2;
        & > div {
          flex-basis: 50%;
          color: inherit;
        }

      }
      &-label {
        font-weight: 700;
        color: inherit;
      }
      &-group-title {
        padding-bottom: 15px;
      }
    }
    a:hover {
      cursor: pointer;
    }
    .btn-hint {
      color: #858585;
      font-size: 12px;
      font-weight: 700;
      padding-bottom: 10px;
    }

    .buttons {
      padding-top: 50px;
    }

    .register-row a {
      color: #295770;
      text-decoration: underline;
    }

    .diya-check {
      grid-row-gap: 20px;
    }

    @media (max-width: 560px) {
      .register {
        &-row {
          flex-direction: column;
        }
      }
    }
  </style>
